import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SIM_TYPES } from '@interfaces/sim.interace';

import { ModalComponent } from '@shared/modal/modal.component';

import { ACTION_CLICK } from './../../../../shared/tag/tag.interface';

@Component({
    selector: 'checkout-esim-modal',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    templateUrl: './esim-modal.component.html',
    styleUrls: [],
})
export class EsimModalComponent extends ModalComponent {
    @Input() type: SIM_TYPES;
    public SIM_TYPES = SIM_TYPES;

    ngOnInit(): void {
        this.tagService.send({
            nomClic:
                this.type === SIM_TYPES.QRESIM
                    ? 'Affichage_modale_incompatibilite_eSIM'
                    : 'Affichage_modale_incompatibilite_carte_SIM',
            categorieClic:
                this.type === SIM_TYPES.QRESIM ? 'Modale_incompatibilite_eSIM' : 'Modale_incompatibilite_carte_SIM',
            actionClic: ACTION_CLICK.PRINTING,
        });
    }
    confirmChoice(choice: boolean): void {
        this.modalRef.close({ data: { simChoice: choice } });
    }
}
